/** App-wide config. Env vars must be prefixed with REACT_APP_ to be exposed. */
export const SUPPORT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL || 'info@pleerityenterprise.co.uk';
